<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="selectProjectCategory">
            <van-loading
                class="pageLogin"
                v-if="isloading"
                type="spinner"
                color="#1989fa"
            ></van-loading>
            <van-nav-bar
                :title="title"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section>
                <ul class="list">
                    <template v-for="(item, index) in listData">
                        <li
                            :key="index"
                            @click="confirmSelection(item)"
                        >
                            {{ item.name }}
                        </li>
                    </template>
                </ul>
            </section>
        </div>
    </v-touch>
</template>

<script>

export default {
    // 选择工程性质
    name: 'select-project-category',
    components: {},
    props: {},
    data() {
        return {
            title: '',
            value: '',
            isloading: '',
            // 列表集合
            listData: [],
            // 线索登记数据
            clueDataData: {},
        };
    },
    computed: {},
    watch: {},
    created() {
        this.title = this.$route.params.title;
        // 线索登记数据
        this.clueDataData = this.$route.params.clueData;
        // 获取列表数据
        this.gitListData();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上级页面
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 获取列表数据
        gitListData() {
            this.isloading = true;
            this.$axios
                .get('/interfaceApi/baseinfo/dictionary_config/getlist?parent_code=103')
                .then(res => {
                    this.listData = res;
                    this.isloading = false;
                }).catch(error => {
                    this.isloading = false;
                    this.$dialog({ message: error });
                });
        },
        // 确认选择
        confirmSelection(data) {
            this.$router.isBack = 1;
            this.clueDataData.engineering_property = data.name;
            this.$router.replace({
                path: '/clueRegistration',
                query: {
                    data: this.clueDataData,
                },
            });
        },
    },
};
</script>
<style lang="stylus">
.selectProjectCategory
    height 100%
    .van-search
        height 44rpx
        background #E6E6E7
        .van-cell
            padding 3rpx 8rpx 3rpx 0
        .van-search__content
            border-radius 4rpx
            background #fff
            .van-field__control
                &::placeholder
                    color #D7D7D7 !important
    section
        height calc(100% - 45rpx)
        overflow: hidden;
        .list
            height calc(100% - 45rpx)
            overflow scroll
            -webkit-overflow-scrolling touch
            li
                height 46rpx
                background #fff
                border-bottom 1px solid #F0F0F0
                font-size 15rpx
                line-height 46rpx
                color #333333
                padding-left 15rpx
                overflow hidden
                text-overflow ellipsis
                white-space nowrap
</style>